import type { RootState } from '@app/store';
import { WORK_SCHEDULE_SERVICE } from '@app/store';

export const selectPage = (state: RootState) =>
  state[WORK_SCHEDULE_SERVICE].page;
